import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const fetchChatConfigAction = createAsyncAction(
  '@chat/FETCH_CHAT_CONFIG_REQUEST',
  '@chat/FETCH_CHAT_CONFIG_SUCCESS',
  '@chat/FETCH_CHAT_CONFIG_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFetchChatConfig: true
})

const success = (state: ChatState, action: ActionType<typeof fetchChatConfigAction.success>): ChatState => {
  const { chatConfig } = action.payload
  return {
    ...state,
    chatConfig,
    isSuccessOnFetchChatConfig: true,
    isLoadingFetchChatConfig: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFetchChatConfig: false,
  isErrorOnFetchChatConfig: true
})

export const fetchChatConfigHandle = { asyncAction: fetchChatConfigAction, request, success, failure }
